// @flow
import React, { useCallback, useState } from "react";
import BootstrapModal from "react-bootstrap-modal";

export const Modal = ({
  mountOnShow = false,
  show,
  onEnter,
  onExited,
  ...props
}: *) => {
  const [fechando, defineFechando] = useState(false);

  const aoEntrar = useCallback(
    event => {
      onEnter && onEnter(event);
      defineFechando(true);
    },
    [onEnter]
  );

  const aoFinalizado = useCallback(
    event => {
      onExited && onExited(event);
      defineFechando(false);
    },
    [onExited]
  );

  if (mountOnShow) {
    return show || fechando ? (
      <BootstrapModal
        show={show}
        onEnter={aoEntrar}
        onExited={aoFinalizado}
        {...props}
      />
    ) : null;
  } else {
    return <BootstrapModal show={show} {...props} />;
  }
};

Modal.Header = BootstrapModal.Header;
Modal.Title = BootstrapModal.Title;
Modal.Body = BootstrapModal.Body;
